<template>
    <div>
        <base-header type="gradient-success" class="pb-7">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h1 class="d-inline-block mb-0">Datenschutz</h1>
                </div>
            </div>
        </base-header>
        <div class="container-fluid mt--7">
            <div class="row">
                <card header-classes="bg-transparent" class="card-pricing border-0 mb-4">
                    <div v-html="htmlFileText"></div>
                </card>
            </div>
        </div>
    </div>
</template>

<script>
import {ref, onMounted} from 'vue';
import htmlFileContent from '@/views/Pages/Support/dataProtection'

export default {
    name: "Help",
    components: {},
    props: {},
    setup() {
        const htmlFileText = ref('')
        onMounted(() => {
            htmlFileText.value = htmlFileContent
        })
        return {
            htmlFileText
        };
    },

}
</script>

<style scoped>

</style>
